/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GasStationClaimResponse
 */
export interface GasStationClaimResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GasStationClaimResponse
     */
    success: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GasStationClaimResponse
     */
    bonusGranted: boolean;
    /**
     * 
     * @type {number}
     * @memberof GasStationClaimResponse
     */
    bonusFuel?: number;
    /**
     * 
     * @type {string}
     * @memberof GasStationClaimResponse
     */
    message?: string;
    /**
     * Seconds remaining in validity window for bonus
     * @type {number}
     * @memberof GasStationClaimResponse
     */
    validityRemaining?: number;
    /**
     * Updated user fuel balance after claim
     * @type {number}
     * @memberof GasStationClaimResponse
     */
    userFuelBalance?: number;
}

/**
 * Check if a given object implements the GasStationClaimResponse interface.
 */
export function instanceOfGasStationClaimResponse(value: object): value is GasStationClaimResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('bonusGranted' in value) || value['bonusGranted'] === undefined) return false;
    return true;
}

export function GasStationClaimResponseFromJSON(json: any): GasStationClaimResponse {
    return GasStationClaimResponseFromJSONTyped(json, false);
}

export function GasStationClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GasStationClaimResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'bonusGranted': json['bonusGranted'],
        'bonusFuel': json['bonusFuel'] == null ? undefined : json['bonusFuel'],
        'message': json['message'] == null ? undefined : json['message'],
        'validityRemaining': json['validityRemaining'] == null ? undefined : json['validityRemaining'],
        'userFuelBalance': json['userFuelBalance'] == null ? undefined : json['userFuelBalance'],
    };
}

export function GasStationClaimResponseToJSON(json: any): GasStationClaimResponse {
    return GasStationClaimResponseToJSONTyped(json, false);
}

export function GasStationClaimResponseToJSONTyped(value?: GasStationClaimResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'bonusGranted': value['bonusGranted'],
        'bonusFuel': value['bonusFuel'],
        'message': value['message'],
        'validityRemaining': value['validityRemaining'],
        'userFuelBalance': value['userFuelBalance'],
    };
}

